<inline-skjema>
  @if (visLastGenerertMoetereferatMelding()) {
    <inline-melding type="info" class="transkripsjonsstatus ikke-print" voksHorisontalt="true" data-testid="transkripsjonsstatus" @fadeInnUt>
      @if (generererMoetereferat()) {
        <span class="generer">
          <mat-progress-spinner mode="indeterminate" diameter="15"/>
          {{ 'Vennligst vent mens forslag til protokoll genereres...' | translate }}
        </span>
      } @else {
        <span (click)="genererMoetereferat()" class="klar-til-generering">
          {{ 'Lydopptaket av møtet ({varighet}) er transkribert' | translate:{varighet: (transkripsjonInformasjon().totalVarighet | duration : 'timerMinutterKort')} }},
          <a data-testid="last-generert-møtereferat-knapp">{{ 'klikk her for å få generert forslag til protokoll.' | translate }}</a>
        </span>
      }
    </inline-melding>
  }

  @if (skjemaGjenopprettet() != null) {
    <inline-melding type="advarsel" voksHorisontalt="true" data-testid="skjema-gjenopprettet">
      {{ 'Ikke-lagrede endringer fra {dato} ({relativDato}) redigert av {av} har blitt gjenopprettet, klikk på avbryt for å forkaste disse endringene'|translate: {dato: skjemaGjenopprettet()!.oppdatertDato|zoneddatetime, relativDato: skjemaGjenopprettet()!.oppdatertDato|zoneddatetime_relativ|async, av: skjemaGjenopprettet()!.eier.navn} }}
    </inline-melding>
  }

  @if (skjemalaasErrorRespons() != null) {
    <inline-melding type="advarsel" voksHorisontalt="true" data-testid="protokoll-redigeres-av-annen">
      {{ 'Protokoll redigeres allerede av {av} (siste endring {dato}, {relativDato}), dersom du velger å lagre endringene dine vil dette kunne føre til tap av data'|translate: {dato: skjemalaasErrorRespons()!.konflikt.oppdatertDato|zoneddatetime, relativDato: skjemalaasErrorRespons()!.konflikt.oppdatertDato|zoneddatetime_relativ|async, av: skjemalaasErrorRespons()!.konflikt.eier.navn} }}
    </inline-melding>
  }

  <form [formGroup]="skjema" (ngSubmit)="lagre()">
    <inline-skjema-blokk>
      <ramme-med-tittel [tittel]="'Dato og sted' | translate">
        <ramme-innhold>
          <moeteprotokoll-rediger-detaljer [skjema]="skjema.controls.detaljer"/>
        </ramme-innhold>
      </ramme-med-tittel>

      <ramme-med-tittel [tittel]="'Deltakere' | translate" class="deltakere">
        <ramme-innhold>
          <moeteprotokoll-rediger-deltakere [skjema]="skjema.controls.deltakere"/>
        </ramme-innhold>
      </ramme-med-tittel>
    </inline-skjema-blokk>

    @for (sak of skjema.controls.saker.controls; track sak.value.sak!.id) {
      <inline-skjema-blokk data-testid="saksreferat-kontainer">
        <!--toggleKlasseVedSticky er med her slik at det i css er mulig å oppdage at sakstittel har blitt sticky - brukes i møte.scss for da å gjøre møtetittel ikke-sticky -->
        <h3 class="sak-overskrift" toggleKlasseVedSticky>
          <span class="nummer">{{ sak.value.sak!.nummer }}</span>
          <span class="tittel" data-testid="sak-tittel">{{ sak.value.sak!.tittel }}</span>
        </h3>
        <moeteprotokoll-rediger-saksreferat [skjema]="sak"
                                            [gruppeId]="moete().eiendeGruppeId"
                                            [avstemningsstatus]="avstemningsstatus()"
                                            [eksponerVisGenerertSaksreferatKnapp]="harTilgangTilProtokollforslag()"
                                            [generertSaksreferat]="genererteSaksreferater().get(sak.value.sak!.id) ?? utenGenerertSaksreferat()"/>
      </inline-skjema-blokk>
    }

    <!-- referatet møteopptaket ga uten at det lot seg knytte til en sak på møtet. Kun til gjennomlesning,
     det finnes ingen sak å lime det inn i -->
    @if (genererteSaksreferaterUtenSak().length > 0) {
      <inline-skjema-blokk data-testid="genererte-saksreferater-uten-sak">
        <h3 class="sak-overskrift">
          <span class="tittel">{{ 'Saksbehandling som ikke kunne knyttes til eksisterende saker i møtet'|translate }}</span>
        </h3>
        <div class="referater-uten-sak">
          <tips>{{ 'Følgende saker ble omtalt uten at Styreplan klarte å finne den tilsvarende saken i den registrerte agendaen. Du må manuelt kopiere tekstene dit du måtte ønske.'|translate }}</tips>

          @for (saksreferat of genererteSaksreferaterUtenSak(); track $index) {
            <ramme-med-tittel data-testid="generert-saksreferat-uten-sak" [tittel]="saksreferat.tittel">
              <ramme-innhold>
                <!-- saniterInnhold da teksten er generert av KI, og derfor ikke sanitert av server slik lagret innhold er -->
                <html-formatert [innhold]="saksreferat.oppsummering" saniterInnhold="true" data-testid="generert-oppsummering-uten-sak"/>

                @for (generertBeslutning of saksreferat.beslutninger; track $index) {
                  <div class="generert-beslutning" data-testid="generert-beslutning-uten-sak">
                    <div class="beslutning-innhold">
                      <mat-icon fontSet="lederplan-ikon-beslutning" class="mat-icon--lederplan-ikon entitetikon"/>
                      <html-formatert [innhold]="generertBeslutning.beskrivelse" saniterInnhold="true"/>
                    </div>

                    <div class="oppgaver">
                      @for (generertOppgave of generertBeslutning.oppgaver; track $index) {
                        <div class="generert-oppgave" data-testid="generert-oppgave-uten-sak">
                          <mat-icon fontSet="lederplan-ikon-oppgave" class="mat-icon--lederplan-ikon entitetikon"/>
                          <div class="oppgave-innhold">
                            <div class="tittel">{{ generertOppgave.tittel }}</div>
                            <html-formatert [innhold]="generertOppgave.beskrivelse" saniterInnhold="true"/>
                            <div class="detaljer">
                              @if (generertOppgave.ansvarlig != null) {
                                <span>{{ generertOppgave.ansvarlig!.navn }}</span>
                              }
                              @if (generertOppgave.frist != null) {
                                <span>{{ 'Frist {frist}'|translate: {frist: generertOppgave.frist|plaindate} }}</span>
                              }
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
              </ramme-innhold>
            </ramme-med-tittel>
          }
        </div>
      </inline-skjema-blokk>
    }

    <inline-skjema-blokk>
      @if (signatarer().eksterne.length > 0) {
        <inline-melding
                type="advarsel">{{ 'Det er huket av for at {antall} eksterne deltakere skal signere protokoll, merk at disse ikke kan signere elektronisk eller få tilgang til Styreplan'|translate: {antall: signatarer().eksterne.length} }}
        </inline-melding>
      }
      <moeteprotokoll-signatarer [signatarer]="signatarer()"/>
      @if (signatarer().interne.length == 0 && signatarer().eksterne.length == 0) {
        <tips>{{ 'Du kan angi hvem som skal signere protokollen øverst i dette skjemaet'|translate }}</tips>
      }
    </inline-skjema-blokk>

    <inline-skjema-handlinger navigasjonforhindret-flash>
      <submit-button [skjema]="skjema" [arbeidPaagaar]="lagrer()" [spinnerTekst]="'Lagrer...'|translate">
        {{ 'Lagre'|translate }}
      </submit-button>
      <button mat-stroked-button type="button" (click)="avbryt()">
        {{ 'Avbryt'|translate }}
      </button>

      <button mat-button color="primary" [matMenuTriggerFor]="limInnMeny" type="button">{{ 'Lim inn...'|translate }}</button>
      <mat-menu #limInnMeny="matMenu" class="lim-inn-meny">
        <button mat-menu-item type="button" (click)="limInnAlleSaksbeskrivelser()">
          <div>{{ 'Lim inn alle saksbeskrivelser'|translate }}</div>
          <div class="sublinje">{{ '{antall} saksbeskrivelser kopieres inn som referattekst'|translate : {antall: antallSaksbeskrivelserTilInnliming()} }}</div>
        </button>
        <button mat-menu-item type="button" (click)="limInnAlleBeslutningsforslag()">
          <div>{{ 'Lim inn alle beslutningsforslag'|translate }}</div>
          <div class="sublinje">
            @if (antallBeslutningsforslag() > 0) {
              {{ 'Endrer {antall} beslutningsforslag til beslutninger'|translate : {antall: antallBeslutningsforslag()} }}
            } @else {
              {{ 'Saken inneholder ingen beslutningsforslag'|translate }}
            }
          </div>
        </button>
        @if (harTilgangTilProtokollforslag()) {
          <button mat-menu-item type="button" data-testid="lim-inn-referat-fra-moeteopptak" [disabled]="!transkripsjonInformasjon().oppsummertMoetereferatTilgjengelig" (click)="limInnReferatFraMoeteopptak()">
            {{ 'Lim inn referat fra møteopptak'|translate }}
          </button>
          @if (transkripsjonInformasjon().oppsummertMoetereferatTilgjengelig && brukerHarKiFeature()){
            <!-- på sikt bør dette innslaget fjernes -->
            <button mat-menu-item type="button" data-testid="regenerer-moetereferat" (click)="regenererMoetereferat()">
              <mat-icon>psychology</mat-icon>
              <span>Test generer-protokollforslag-prompt (debug)</span>
            </button>
          }
        }
      </mat-menu>

      @if (antallFeil() > 0) {
        <div class="feil" (click)="gaaTilFoersteFeil()" data-testid="har-feil">{{ 'Skjemaet inneholder {antall} feil, gå til første'|translate :{antall: antallFeil()} }}</div>
      }

      @if (visSkjemalaasOppdateringPaagaar()){
        <div class="skjemalåsoppdatering-pågår" data-testid="skjemalåsoppdatering-pågår" @fadeInnUt>
          <mat-progress-spinner mode="indeterminate" diameter="15"/>
          <div>{{'Sikkerhetskopierer skjema'|translate}}</div>
        </div>
      }

    </inline-skjema-handlinger>
  </form>
</inline-skjema>


<!-- dialog som vises dersom bruker avbryter redigering og skjema er gjenopprettet -->
<ng-template #forkastGjenopprettedeEndringerDialogTemplate>
  <div class="mappe-kan-ikke-slettes-dialog" data-testid="mappe-kan-ikke-slettes-dialog">
    <h2 mat-dialog-title>{{ "Vil du forkaste gjenopprettede skjemaendringer"|translate}}</h2>
    <mat-dialog-content>
      <p>{{ "Ikke-lagrede endringer fra {dato} redigert av {av} har blitt gjenopprettet, er du sikker på at du vil forkaste disse permanent?" | translate: {dato:skjemaGjenopprettet()!.oppdatertDato|zoneddatetime, av: skjemaGjenopprettet()!.eier.navn} }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button type="button" [mat-dialog-close]="false">{{ "Fortsett redigering"|translate }}</button>
      <button mat-raised-button color="warn" type="button" [mat-dialog-close]="true">{{ "Forkast"|translate }}</button>
    </mat-dialog-actions>
  </div>
</ng-template>
